<div mat-dialog-title>
  Selecteer een gebruiker
  <button [mat-dialog-close]="false" class="mat-black" mat-flat-button>
    <mat-icon>close</mat-icon>
    Sluiten
  </button>
</div>
<div mat-dialog-content>
  <mat-form-field style="width:100%">
    <mat-label>Gebruiker</mat-label>
    <mat-select [formControl]="form.controls.user_id">
      <mat-option>
        <ngx-mat-select-search [formControl]="filterUsersCtrl"></ngx-mat-select-search>
      </mat-option>
      <mat-option *ngFor="let option of filteredUsers | async" [value]="option.id">
        {{ option.name }}
        <span class="user-departments" *ngIf="option.department">({{ option.department.name }})</span>
        <span class="user-availability" *ngIf="!option.is_user_available">
          <mat-icon color="warn" [matTooltip]="'Gebruiker is afwezig tot ' + formatDate(option.unavailable_to)">info</mat-icon>
        </span>
      </mat-option>
    </mat-select>
    <mat-spinner *ngIf="filters.users.isLoading" diameter="20"></mat-spinner>
    <button (click)="clearValue('user_id');$event.stopImmediatePropagation()" *ngIf="form.controls.user_id.value" aria-label="Clear" mat-icon-button matSuffix>
      <mat-icon>close</mat-icon>
    </button>
  </mat-form-field>

  <mat-form-field style="width:100%;">
    <mat-label>Waarom moet deze taak toegekend worden aan iemand anders?</mat-label>
    <textarea [formControl]="form.controls.note" matInput maxlength="2000" rows="3"></textarea>
    <mat-hint align="end">
      {{ form.controls.note.value.length }} / 2000
    </mat-hint>
  </mat-form-field>

</div>
<mat-dialog-actions>
  <button (click)="submit(form.value)" [disabled]="!form.valid" color="primary" mat-flat-button>OPSLAAN</button>
</mat-dialog-actions>
<fury-loading-overlay [isLoading]="isLoading" [fill]="true"></fury-loading-overlay>
